const getPageBasedRequestor = function() {
  if (window && window.location && window.location.href) {
    return `pcxt-${encodeURIComponent(window.location.href.substring(0, 100))}`;
  }
  return "pcxt";
};

export { getPageBasedRequestor };
//# sourceMappingURL=web-http.js.map
